import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormFieldType } from '@wdx/shared/utils';
import {
    FormFrameworkEvent,
    ReactiveFormLayoutAndDefinition,
} from '../../models';

@Component({
    selector: 'wdx-ff-controls-container',
    templateUrl: './form-controls-container.component.html',
    standalone: false,
    host: { class: 'd-block position-relative' },
})
export class FormControlsContainerComponent {
    @Input() entityId!: string;
    @Input() formElement!: ReactiveFormLayoutAndDefinition;
    @Input() formContext!: any;

    @Output() formEvent = new EventEmitter<FormFrameworkEvent>();

    constructor(public controlContainer: ControlContainer) {}

    readonly FormFieldType = FormFieldType;
}
